import { render, staticRenderFns } from "./complex-project-viewer.html?vue&type=template&id=3b08d40a&"
import script from "./complex-project-viewer.js?vue&type=script&lang=js&"
export * from "./complex-project-viewer.js?vue&type=script&lang=js&"
import style0 from "./complex-project-viewer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports